import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {GoogleService} from './google-service';
import {OrgunitXBrand} from "../organization/organization-brands/orgunit-x-brand";
import {BrandID} from "../enums/brand-id";

@Service()
export class OrganizationBrandsService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getByOrgUnitId(orgUnitId: string): Observable<OrgunitXBrand[]> {
    let url = this.urlBase + 'orgunitbrands/' + orgUnitId;
    return this.http.get<OrgunitXBrand[]>(url, {headers: this.getHeaders()});
  }

  public getOrgUnitXBrand(orgUnitId: string, brandID: BrandID): Observable<OrgunitXBrand> {
    let url = this.urlBase + 'orgunitbrands/' + orgUnitId + '/' + brandID;
    return this.http.get<OrgunitXBrand>(url, {headers: this.getHeaders()});
  }

  public delete(orgUnitId: string, brandID: BrandID): void {
    let url = this.urlBase + 'orgunitbrands/' + orgUnitId + '/' + brandID;
    this.http.delete(url, {headers: this.getHeaders()});
  }

  public deleteByOrgUnitId(orgUnitId: string): Observable<string> {
    let url = this.urlBase + 'orgunitbrands/' + orgUnitId;
    return this.http.delete(url, {headers: this.getHeaders(), responseType: 'text'});
  }

  public insert(orgUnitId: string, brandID: BrandID): Observable<string> {
    let url = this.urlBase + 'orgunitbrands/' + orgUnitId + '/' + brandID;
    return this.http.put(url, {}, {headers: this.getHeaders(), responseType: 'text'});
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }


}

